import { render, staticRenderFns } from "./os.vue?vue&type=template&id=c7bdf800&scoped=true&"
import script from "./os.vue?vue&type=script&lang=js&"
export * from "./os.vue?vue&type=script&lang=js&"
import style0 from "./os.vue?vue&type=style&index=0&id=c7bdf800&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7bdf800",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a2\\Code_New\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7bdf800')) {
      api.createRecord('c7bdf800', component.options)
    } else {
      api.reload('c7bdf800', component.options)
    }
    module.hot.accept("./os.vue?vue&type=template&id=c7bdf800&scoped=true&", function () {
      api.rerender('c7bdf800', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sys/os.vue"
export default component.exports